<template>
  <div>
    <div class="title-option">การตั้งค่าสำหรับทุกตัวเลือกสินค้า</div>
    <div class="option">ตัวเลือกสินค้า</div>
    <div
      class="group-option"
      v-for="(serviceOptionCost, serviceOptionCostIndex) in serviceOptionCosts"
      :key="serviceOptionCostIndex"
    >
      <div
        class="combine-option"
        v-for="(combinationCost, combinationCostIndex) in serviceOptionCost.combination_costs"
        :key="combinationCostIndex"
      >
        <div class="row">
          <div class="col-4">
            <div class="main-title" v-if="combinationCostIndex === 0">
              {{ combinationCost.title }}
            </div>
            <div v-else class="sub-title">+ {{ combinationCost.title }}</div>
          </div>
          <div class="col-8">
            <div
            class="detail-option"
              v-for="(
                appointmentCost, appointmentCostIndex
              ) in combinationCost.appointment_costs"
              :key="appointmentCostIndex"
            >
              <div class="col-12">
                <div class="row">
                  <div
                    class="col-2 appointment-cost"
                    v-if="serviceOptionCost.is_product === false"
                  >
                    ครั้งที่{{ appointmentCost.appoint_no }}
                  </div>
                  <div class="input-appointment">
                    <span>ราคาทุน</span>
                  </div>
                  <div class="col-4 input-appointment-cost">
                    <el-input
                      type="number"
                      :disabled="hasOptionSwitch"
                      v-model="appointmentCost.cost"
                      @input="
                        handleCombineAppointmentCost(
                          serviceOptionCostIndex,
                          combinationCostIndex,
                          appointmentCostIndex,
                          $event
                        )
                      "
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Checkbox, Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";

export default {
  props: ["value"],
  components: {
    "el-checkbox": Checkbox,
    ScButton,
    "el-input": Input
  },
  data() {
    return {
      packageOption: null
    };
  },
  computed: {
    serviceOptionCosts: {
      get() {
        return this.value.serviceOptionCosts;
      },
    },
    hasOptionSwitch() {
      return this.value.hasOptionSwitch;
    }
  },
  methods: {
    handleCombineAppointmentCost(
      combinationCostIndex,
      variantIndex,
      appointmentCostIndex,
      cost
    ) {
      const serviceOptionCosts = this.value.serviceOptionCosts.map(
        (serviceOptionCost, index) => {
          if (combinationCostIndex === index) {
            serviceOptionCost.combination_costs.map(
              (combinationCost, combineOptionIndex) => {
              if (variantIndex === combineOptionIndex) {
                combinationCost.appointment_costs.map(
                  (appointCost, appointCostIndex) => {
                    if (appointmentCostIndex === appointCostIndex) {
                      appointCost.cost = cost;
                    }

                    return appointCost;
                  }
                );
              }

              return combinationCost;
            });
          }

          return serviceOptionCost;
        }
      );

      this.$emit("input", serviceOptionCosts);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.title-option {
  margin-top: 20px;
  margin-bottom: 4px;
}

.option {
  border: $border-head;
  height: 50px;
  padding: 10px;
  background: #f2f2f2;
}

.group-option {
  border: $border-head;
  border-top: 0;
}

.combine-option {
  padding-left: 25px;
  border: $border;
  height: auto;
}

.detail-option {
  border-left: $border;
  border-bottom: $border;
  padding: 0px;
  font-size: 12px;
  height: 50px;
}

.detail-option:last-child{
  border-bottom: 0;
}

.appointment-cost {
  border-right: $border;
  text-align: center;
  margin-top: 10px;
}

.input-appointment {
  margin-top: 10px;
  margin-left: 10px;
  column-width: 50px;
}

.input-appointment-cost {
  margin-top: 5px;
  padding-right: 0px;
}

.main-title {
  padding-top: 15px;
  font-size: 17px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
}

.sub-title {
  padding-left: 20px;
  padding-top: 15px;
  font-size: 15px;
}

.grid-container {
  display: grid;
  padding: 20px;
  grid-template-columns: 70px 55px 180px;
  grid-gap: 10px;
  padding: 10px;
  border-bottom: $border;
}
</style>


// WEBPACK FOOTER //
// src/features/subscriptions/modules/services/components/ServiceListOption.vue